import { IVentureExperienceLevelBase } from '../../models/ventureExperienceLevels';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateVentureExperienceLevelsProps {
  ventureId: string;
  maxAllowedBookingExperience: number;
  minAllowedBookingExperience: number;
  title: string;
  level: number;
}

export type INewVentureExperienceLevel = IVentureExperienceLevelBase;

export const createVentureExperienceLevelsService = async ({
  ventureId,
  maxAllowedBookingExperience,
  minAllowedBookingExperience,
  title,
  level,
}: ICreateVentureExperienceLevelsProps): Promise<INewVentureExperienceLevel> => {
  const { data } = await jhsfBookingsApi.post<INewVentureExperienceLevel>(
    `/ventures/${ventureId}/experience-levels`,
    {
      maxAllowedBookingExperience,
      minAllowedBookingExperience,
      title,
      level,
    },
  );

  return data;
};
